import { CURRENCIES, EXCHANGES } from '@/lib/types/generalTypes';
import { PLANS } from '../payments/paymentsTypes';
import { COLUMNS_NAMES } from '@/state/general/generalTypes';

export enum MEMBER_STATUS {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    SUSPENDED = 'suspended',
}

export enum LANGUAGES {
    EN = 'en',
    RU = 'ru',
    UK = 'uk',
    KO = 'ko',
    JA = 'ja',
    ZH = 'zh',
    DE = 'de',
}

export enum ALIGNING {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}

export enum ALIGNING_DISPLAY {
    LEFT = 'left_aligning_label',
    CENTER = 'center_aligning_label',
    RIGHT = 'right_aligning_label',
}

export enum THEME_VARIANTS {
    DARK = 'dark',
    LIGHT = 'light',
}

export enum THEME_VARIANTS_DISPLAY {
    DARK = 'dark_theme_label',
    LIGHT = 'light_theme_label',
}

export enum BROWSER_TAB {
    // currentSelectedExchangeBtc = 'current_selected_exchange_btc',
    // currentSelectedExchangeFiat = 'current_selected_exchange_fiat',
    totalNetWorthFiat = 'total_net_worth_fiat',
    totalNetWorthBtc = 'total_net_worth_btc',
}

export enum BROWSER_TAB_DISPLAY {
    // currentSelectedExchangeBtc = 'current_selected_exchange_btc',
    // currentSelectedExchangeFiat = 'current_selected_exchange_fiat',
    totalNetWorthFiat = 'total_net_worth_fiat',
    totalNetWorthBtc = 'total_net_worth_btc',
}

export interface MemberSettings {
    timezone?: string;
    fiatNativeCurrency: string;
    siteCurrency: string;
    updated: string;
    theme: THEME_VARIANTS;
    browserTabDisplay: BROWSER_TAB;
    adminAccessAllowed: boolean;
    emailMarketingAllowed: boolean;
    priceHighlight?: boolean;
    maxBreakeven: number | null;
    minBreakeven: number | null;
    showGmArt: boolean;
    isFavoriteMenu: boolean;
    menuCollapsed: boolean;
    lang: string;
    contentAlignment: string;
    tradeHistoryColumns: { [key in COLUMNS_NAMES]: boolean };
}

export type UsedSlots = Record<EXCHANGES, number>;

export interface AccountType {
    accountType: PLANS;
    expiredAt: string;
    effectiveAt: string;
    source:
        | 'freebee'
        | 'paypal'
        | 'stripe'
        | 'coinpayments'
        | 'user'
        | 'rewards-hub'
        | 'global-unlocked'
        | null;
}

export interface MemberSlots {
    usedSlots: UsedSlots;
    totalSlots: number;
}

export interface Profile {
    status: MEMBER_STATUS;
    id: number | null;
    username: string;
    firstName: string | null;
    lastName: string | null;
    country: any;
    email: string;
    role: number;
    verified: boolean;
    created: string;
    slots: MemberSlots;
    accountType: AccountType;
}

export interface ConnectedTelegramData {
    id: number;
    chatId: string;
    memberId: number;
    firstName: string;
    lastName: string;
    username: string;
    type: string;
    created: string;
    updated: string;
    active: true;
}

export interface InitialMemberState {
    isAuth: boolean;
    activeCurrency: CURRENCIES;
    settings: MemberSettings;
    twitterAccount: ConnectedTwitterData | null;
    profile: Profile;
    referrer: string | null;
    telegramAccount: ConnectedTelegramData | null;
}

export interface ConnectedTwitterData {
    memberId: number;
    twitterId: string;
    twitterScreenName: string;
    twitterProfile: {
        screenName: string;
        profileImageUrl: string;
        name: string;
        description: string;
        verified: boolean;
        publicMetrics: {
            followersCount: number;
            followingCount: number;
            listedCount: number;
            tweetCount: number;
        };
    };
    created: string;
    updated: string;
}
